const USER_BASE_URL = (process.env.REACT_APP_USER_SERVICE_URL || 'http://localhost:3003').replace(/\/$/, '');

const buildQueryString = (params = {}) => {
  const entries = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(
          typeof value === 'number' ? value : String(value),
        )}`,
    );
  return entries.length > 0 ? `?${entries.join('&')}` : '';
};

const handleResponse = async (response) => {
  if (response.status === 204) {
    return null;
  }

  const text = await response.text();
  if (text.length === 0) {
    if (!response.ok) {
      throw new Error('Error desconocido en el servicio de usuarios');
    }
    return null;
  }

  let payload;
  try {
    payload = JSON.parse(text);
  } catch {
    payload = { message: text };
  }

  if (!response.ok) {
    const message = payload?.message || 'Error desconocido en el servicio de usuarios';
    throw new Error(message);
  }

  return payload;
};

export const getCurrentUsuario = (authFetch) =>
  authFetch(`${USER_BASE_URL}/users/me`, {
    method: 'GET',
  }).then(handleResponse);

export const updateCurrentUsuario = (authFetch, data) =>
  authFetch(`${USER_BASE_URL}/users/me`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(handleResponse);

export const getCiudadOptions = (authFetch) =>
  authFetch(`${USER_BASE_URL}/users/catalog/cities`, {
    method: 'GET',
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-store',
      Pragma: 'no-cache',
    },
  }).then(handleResponse);

export const getProfesionesCatalog = (authFetch, params = {}) =>
  authFetch(
    `${USER_BASE_URL}/users/catalog/professions${buildQueryString(params)}`,
    {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-store',
        Pragma: 'no-cache',
      },
    },
  ).then(handleResponse);

export const getOccupationFieldOptions = (authFetch, params = {}) =>
  authFetch(
    `${USER_BASE_URL}/users/catalog/occupation-fields${buildQueryString(params)}`,
    {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-store',
        Pragma: 'no-cache',
      },
    },
  ).then(handleResponse);

const userService = {
  getCurrentUsuario,
  updateCurrentUsuario,
  getCiudadOptions,
  getProfesionesCatalog,
  getOccupationFieldOptions,
};

export default userService;
